<template>
	<div class="add_Words_wrap">
    <el-button type="primary" size="small" @click="pop_show = true" class="pull-right">新增词汇</el-button>
    <el-dialog title="新增词汇" :visible.sync="pop_show" append-to-body>
        <el-form :model="WordForm" status-icon :rules="rulesWordForm" ref="WordForm" label-width="100px">
          <el-form-item label="敏感词：" prop="word">
            <el-input type="text" v-model="WordForm.word" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="权重：" prop="weights">
            <el-input type="text" v-model="WordForm.weights" autocomplete="off" size="small"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="resetForm('WordForm')">重置</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
	</div>
</template>

<script>
import cons from '@/components/constant';

export default {
  name: 'AddWords',
  data () {
    return {
      pop_show:false,
      group_type_list:[],
      category_list:[],
      WordForm:{
        word:'',
        weights:''
      },
      rulesWordForm:{
      }
    }
  },
  methods:{
    submitForm(){
      let token = localStorage.token;
        this.axios.post(cons.apis + '/v1_0/sensitive_words', {
              "word": this.WordForm.word,
              "weights": this.WordForm.weights,
            }, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        })
        .then(dat=>{
            if(dat.status==201){
              this.$message({
                type: 'success',
                message: '词汇添加成功!'
              });
              this.pop_show = false;
              this.resetForm('WordForm');
              this.$emit('fnResetTable');
            }
        }).catch(err=>{
            if(err.response.status==400){
              var errmsg = err.response.data;

              if(errmsg.name){
                this.$message({
                  type:'info',
                  message:errmsg.name[0]
                });
              }

              if(errmsg.non_field_errors){
                this.$message({
                  type:'info',
                  message:errmsg.non_field_errors[0]
                });
              }
           }
        });
    },

    resetForm(formName){
      this.$refs[formName].resetFields();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widget/AddWord.vue